module.exports = __webpack_public_path__ + "static/hkgrotesk-italic-c1ebfdefd3bf106837826f4a66ed4eaa.woff2";